import Link from "next/link"
import { useRouter } from "next/router"
import React, { FC, ReactNode, useCallback } from "react"
import styled from "styled-components"
import { theme } from "../../util/styles/theme"
import { Box } from "../Box/Box"

export interface ArticleCardProps {
  content: string
  date: string
  href: string
  image: ReactNode
  title: string
}

interface ContainerProps {
  onClick: () => Promise<void>
}

const Container = styled(Box)<ContainerProps>`
  display: flex;

  flex-direction: column;

  ${theme.breakpoints.sm} {
    flex-direction: row;
  }
  gap: ${theme.spacings.medium};
  justify-content: space-between;

  cursor: pointer;
`

const ImageContainer = styled(Box)`
  ${theme.breakpoints.sm} {
    flex-basis: 40%;
  }

  padding-top: 0;
  padding-left: 0;
  padding-right: 0;
`

const ContentContainer = styled(Box)`
  flex-basis: 60%;
  padding: 0;
`
const Title = styled.h2`
  margin-top: 0;
  margin-bottom: 0;
`
const Date = styled.time`
  ${theme.textStyle("default", "medium", "normal")};
  color: ${theme.colors.greyDark};
`
const Content = styled.p``

const TitleLink = styled.a`
  text-decoration: none;
  color: inherit;
`
export const ArticleCard: FC<ArticleCardProps> = ({
  title,
  date,
  image,
  content,
  href,
}) => {
  const router = useRouter()

  const handleClick = useCallback(async () => {
    await router.push({
      pathname: href,
    })
  }, [href, router])

  return (
    <Container onClick={handleClick}>
      <ImageContainer>{image}</ImageContainer>
      <ContentContainer>
        <Title>
          <Link href={href} passHref>
            <TitleLink>{title}</TitleLink>
          </Link>
        </Title>
        <Date>{date}</Date>
        <Content>{content}</Content>
      </ContentContainer>
    </Container>
  )
}
